<template>
  <BaseModal :state="state" :open="open" :close="onClose">
    <template #header>
      <HeaderModalEvidencia
        :show-progress="state.header?.showProgress"
        :show-navigation="state.header?.showEvidenciaNavigation"
        :evidencia="state.data?.evidencia"
        :alternativa="state.data?.alternativa"
        :loading="loading?.getEvidencia"
        @click:change="(v) => setState({ data: v })"
      />
    </template>
    <template #content>
      <div
        v-if="loading?.getEvidencia"
        class="size-full flex-1 grid place-items-center"
      >
        <BaseLoader />
      </div>

      <template v-else>
        <QCardSection class="w-full grid grid-cols-2 gap-16 p-24">
          <OInput
            v-if="evidencia.periodo && assessment.show_periods"
            :model-value="evidencia.periodo_nome_exibicao"
            size="md"
            type="text"
            :label="t('currentWindow')"
            disabled
            readonly
            class="col-span-2 label-transparent readonly"
          />

          <OInput
            v-if="evidencia.pergunta.categoria_nome_readonly"
            :model-value="evidencia.pergunta.categoria_nome_readonly"
            size="md"
            type="text"
            :label="t('pillar')"
            disabled
            readonly
            class="label-transparent readonly"
          />

          <OInput
            v-if="evidencia.pergunta.pergunta"
            :model-value="evidencia.pergunta.pergunta"
            size="md"
            type="text"
            :label="t('item')"
            disabled
            readonly
            class="label-transparent readonly"
          />

          <OInput
            :model-value="
              evidencia.alternativas.map((a) => a.titulo).join(', ')
            "
            size="md"
            type="text"
            :label="t('currentMaturityLevel')"
            disabled
            readonly
            class="label-transparent readonly"
          />

          <OInput
            v-if="evidencia.status"
            :model-value="evidencia.status_traduzido"
            size="md"
            type="text"
            :label="t('status')"
            disabled
            readonly
            class="label-transparent readonly"
          />

          <ViewInfosAlternativas
            :alternativas="evidencia.alternativas"
          />
        </QCardSection>

        <QCardSection class="w-full p-0">
          <div
            class="flex border-b border-b-solid border-b-neutral-100/10 flex-nowrap items-center"
          >
            <q-tabs
              v-model="tab"
              class=""
              active-color="primary-pure"
            >
              <q-tab name="atual" class="w-[112px]">
                <p class="!text-headline-3">
                  {{ t('current') }}
                </p>
              </q-tab>

              <q-tab
                v-show="showPrevious"
                name="anteriores"
                class="w-[112px] !bg-white"
              >
                <p class="!text-headline-3">
                  {{ t('previous') }}
                </p>
              </q-tab>
            </q-tabs>
            <div class="flex-1" />
          </div>

          <q-tab-panels v-model="tab" animated class="mb-80">
            <q-tab-panel name="atual" class="overflow-hidden">
              <QCardSection class="flex flex-col gap-16 p-24">
                <FileUploader
                  v-if="modo === 'edicao'"
                  multiple
                  accept=""
                  container-class="h-96 p-12 flex flex-col items-center justify-center gap-6 rounded-md border border-dashed border-neutral-100/10 hover:border-neutral-100/30 bg-card-300 transition-all cursor-pointer"
                  @change="(value) => (model.files = value)"
                >
                  <p class="text-paragraph-4 text-neutral-70">
                    {{ t('attachHereYour') }}
                  </p>
                  <div
                    class="h-32 grid place-items-center bg-white border border-neutral-100/10 rounded-md px-10 mt-8"
                  >
                    <p class="text-headline-4 text-neutral-100">
                      {{ t('selectFiles') }}
                    </p>
                  </div>
                </FileUploader>

                <template
                  v-if="filesData.length && modo !== 'edicao'"
                >
                  <p class="text-caps-3 text-neutral-70">
                    {{ t('attachments') }}
                  </p>

                  <q-list class="w-full space-y-8 -mt-8">
                    <OFileDownload
                      v-for="(file, index) in filesData"
                      :key="index"
                      :file="file"
                      :name="file.arquivo.split('/').pop()"
                    />
                  </q-list>
                </template>

                <OInput
                  v-model="model.comentario"
                  size="lg"
                  type="textarea"
                  stack-label
                  :label="t('comment')"
                  :placeholder="
                    commentDisabled ? '-' : t('writeHere')
                  "
                  :disabled="commentDisabled"
                  :readonly="commentDisabled"
                  :class="commentDisabled ? 'readonly' : ''"
                  class="showPlaceholderOnStack label-transparent"
                />

                <OInput
                  v-model="model.comentario_supervisor"
                  size="lg"
                  type="textarea"
                  :label="t('logbitsComments')"
                  :disabled="commentSupervisorDisabled"
                  :readonly="commentSupervisorDisabled"
                  :class="commentSupervisorDisabled ? 'readonly' : ''"
                  class="label-transparent"
                />
              </QCardSection>
            </q-tab-panel>

            <q-tab-panel name="anteriores">
              <QCardSection class="p-24">
                <p class="text-caps-3 text-neutral-70">
                  {{ t('shipments') }}
                </p>

                <q-list class="w-full space-y-16 mt-16">
                  <template v-if="assessment.show_periods">
                    <q-card
                      v-for="periodo in agrupamentoPeriodo"
                      :key="periodo.id"
                      class="bg-card-200 p-8 rounded-lg border border-neutral-100/10 !shadow-none"
                    >
                      <div
                        class="h-20 flex bg-card-400 rounded-lg px-8"
                      >
                        <p
                          class="text-caps-2 text-neutral-70 self-center"
                        >
                          {{ periodo.nome_exibicao }}
                        </p>
                      </div>

                      <template
                        v-for="evidenciaEnvio in periodo.evidencias_desse_periodo"
                        :key="evidenciaEnvio.id"
                      >
                        <AccordionEnvioEvidencia
                          :agrupamento="
                            evidenciaEnvio.agrupamentoenvio_set
                          "
                        />
                      </template>
                    </q-card>
                  </template>

                  <template v-else>
                    <AccordionEnvioEvidencia
                      :agrupamento="agrupamentoEnvio"
                    />
                  </template>
                </q-list>
              </QCardSection>
            </q-tab-panel>
          </q-tab-panels>
        </QCardSection>

        <div
          class="w-full h-80 absolute bottom-0 left-0 z-10 bg-card-100 border-t border-neutral-100/10 p-16"
        >
          <template v-if="modo === 'edicao'">
            <div class="flex justify-end">
              <OButton
                primary
                size="md"
                :label="t('saveAction')"
                :class="{
                  'opacity-50 pointer-events-none': !enableBtnEditar,
                }"
                class="text-headline-3 !min-w-120"
                @click="
                  $emit('click:editar', { evidencia, ...model })
                "
              />
            </div>
          </template>

          <template v-if="modo === 'avaliacao'">
            <div class="flex items-center justify-between">
              <OCheck
                v-model="model.material_evidencia"
                :label="t('referenceMaterial')"
                size="1.25rem"
                class="text-paragraph-3 text-neutral-60"
              />
              <div class="flex items-center gap-4">
                <OButton
                  :disable="model.material_evidencia"
                  secondary
                  icon-size="1rem"
                  class="size-[2.75rem]"
                  @click="
                    $emit('click:reprovar', { evidencia, ...model })
                  "
                >
                  <q-icon
                    name="svguse:#icon_close"
                    class="text-alert-error"
                  />
                </OButton>
                <OButton
                  secondary
                  class="size-[2.75rem]"
                  @click="
                    $emit('click:aprovar', { evidencia, ...model })
                  "
                >
                  <q-icon
                    name="svguse:#icon_check"
                    class="text-alert-success"
                  />
                </OButton>
              </div>
            </div>
          </template>
        </div>
      </template>

      <BaseInnerLoader
        v-if="loading?.evidencia?.enviando"
        :percent="loading?.evidencia?.porcentagem"
      />
    </template>
  </BaseModal>
</template>

<script setup>
import { computed, inject, ref, watch } from 'vue'
import { statusEvidencia } from 'js/utils/GLOBAL'
import { useEvidencia } from 'composables/useEvidencia'
import { useI18n } from 'vue-i18n'
import AccordionEnvioEvidencia from 'components/Accordion/AccordionEnvioEvidencia.vue'
import BaseInnerLoader from 'components/Loader/BaseInnerLoader.vue'
import BaseLoader from 'components/Loader/BaseLoader.vue'
import BaseModal from 'components/Modal/BaseModal.vue'
import FileUploader from 'components/FileUploader/FileUploader.vue'
import HeaderModalEvidencia from 'components/Header/HeaderModalEvidencia.vue'
import OButton from 'components/Button/OButton.vue'
import OCheck from 'components/Checkbox/OCheck.vue'
import OFileDownload from 'components/FileUploader/OFileDownload.vue'
import OInput from 'components/Input/OInput.vue'
import useAssessment from 'composables/useAssessment'
import useModal from 'composables/useModal'
import usePerguntas from 'composables/usePerguntas'
import ViewInfosAlternativas from 'components/Accordion/ViewInfosAlternativas.vue'

const { t } = useI18n()
const context = inject('context')

const { assessment } = useAssessment()
const { tipoEvidencia } = usePerguntas()
const {
  initialRequestsEvidencia,
  filesData,
  getAnteriores,
  getAnterioresPeriodo,
  agrupamentoEnvio,
  agrupamentoPeriodo,
} = useEvidencia()

const modalEvidencia = useModal()
const { state, open, close, setState } = modalEvidencia

const onClose = () => {
  close()
}

const emit = defineEmits([
  'click:aprovar',
  'click:reprovar',
  'click:editar',
])
const props = defineProps({ loading: Object })

const model = ref({
  files: [],
  comentario: '',
  comentario_supervisor: '',
  material_evidencia: false,
})

const tab = ref('atual')

const enableBtnEditar = computed(() => {
  return (
    model.value.files.length ||
    model.value.comentario !== evidencia.value.comentario
  )
})

const commentDisabled = computed(() => {
  return modo.value !== 'edicao'
})

const commentSupervisorDisabled = computed(() => {
  return modo.value !== 'avaliacao'
})

setState({
  header: {
    title: t('evidences'),
    showEvidenciaNavigation: true,
  },
  style: { width: '50rem', minHeight: '80vh' },
})

const evidencia = computed(() => {
  const evidencia = state.value.data?.evidencia || {}
  const pergunta = state.value.data?.pergunta || null

  if (state.value.data?.alternativa) {
    evidencia.alternativas = [state.value.data.alternativa]
  }

  return {
    pergunta,
    ...evidencia,
  }
})

/**
 * Computed property que define o modo atual do modal, podendo ser:
 * - 'edicao': quando o usuário pode editar a evidência.
 * - 'avaliacao': quando o usuário (admin ou staff) deve avaliar a evidência.
 * - 'visualizacao': quando o usuário apenas visualiza a evidência.
 *
 * Lógica geral:
 * - Aprovada: modo 'edicao', para usuários normais,
 * quando for envio de evidências por pergunta, senão → 'visualizacao'.
 * - Reprovada: modo 'visualizacao' para admins, senão → 'edicao'.
 * - Pendente: modo 'avaliacao' para admins, senão → 'visualizacao'.
 * - Qualquer outro status: 'visualizacao'.
 *
 * @returns {'edicao' | 'avaliacao' | 'visualizacao'}.
 */
const modo = computed(() => {
  const status = statusEvidencia(evidencia.value?.status)
  const admin = context.user?.superuser || context.user?.staff
  const pergunta = evidencia.value?.pergunta
  if (status?.aprovada) {
    if (
      tipoEvidencia.value?.pergunta &&
      pergunta.pode_enviar_evidencia &&
      !admin
    ) {
      return 'edicao'
    }
    return 'visualizacao'
  } else if (status?.reprovada) {
    if (admin || !pergunta.pode_enviar_evidencia) {
      return 'visualizacao'
    }
    return 'edicao'
  } else if (status?.pendente) {
    if (admin) return 'avaliacao'
    return 'visualizacao'
  }
  return 'visualizacao'
})

const showPrevious = computed(() => {
  if (assessment.value.show_periods) {
    return agrupamentoPeriodo.value.length > 0
  }
  return agrupamentoEnvio.value.length > 0
})

watch(
  () => [
    evidencia.value.comentario,
    evidencia.value.comentario_supervisor,
  ],
  ([com, comS]) => {
    model.value.comentario = com || ''
    model.value.comentario_supervisor = comS || ''
  },
  { immediate: true }
)

watch(
  () => state.value?.data?.evidencia?.id,
  async (v) => {
    if (!v) return
    if (assessment.value.show_periods) {
      agrupamentoPeriodo.value = []
      await initialRequestsEvidencia(evidencia.value?.id)
      agrupamentoPeriodo.value = await getAnterioresPeriodo(
        evidencia.value?.id
      )
    } else {
      agrupamentoEnvio.value = []
      await initialRequestsEvidencia(evidencia.value?.id)
      agrupamentoEnvio.value = await getAnteriores(
        evidencia.value?.id
      )
    }
  }
)

watch(
  () => state.value?.open,
  async (open) => {
    if (open) return
    if (assessment.value.show_periods) {
      agrupamentoPeriodo.value = []
    } else {
      agrupamentoEnvio.value = []
    }
  }
)

watch(
  () => showPrevious.value,
  (show) => {
    if (!show && tab.value === 'anteriores') {
      tab.value = 'atual'
    }
  }
)

defineExpose({
  state,
  open,
  close,
  setState,
})
</script>

<style lang="scss" scoped></style>
